import ButtonField from '@/components/form-control/ButtonField'
import { Stack, Typography } from '@mui/material'
import FooterSetup from '../../common/FooterSetup'
import MenuHeader from '../../common/MenuHeader'
import RightGoogleMapSmall from '../../common/RightGoogleMapSmall'
import SetUpLayout from '../../common/SetUpLayout'

type Props = {}

const SensorData = (props: Props) => {
  const handleClick = () => {}

  return (
    <SetUpLayout
      title="Sensor"
      header={<MenuHeader />}
      rightLayout={<RightGoogleMapSmall />}
      footer={
        <Stack p="25px 32px">
          <FooterSetup />
        </Stack>
      }
    >
      <Stack direction="row" alignItems="center" justifyContent="space-between">
        <Typography sx={{ fontSize: '20px', lineHeight: '2.4' }}>
          Review Sensor Data
        </Typography>
        <Stack alignItems="center">
          <ButtonField
            startIcon={<></>}
            style={{
              height: '32px',
              minWidth: '89px',
              borderRadius: '5px',
            }}
            name="Done"
            onClick={handleClick}
          />
        </Stack>
      </Stack>
      {/* <SensorTable rows={DATA_TABLE_SENSORS} /> */}
    </SetUpLayout>
  )
}

export default SensorData
